import React, { createContext, useEffect, useState} from 'react';
import axios from 'axios';
import config from '../config'

export const AuthLoginInfo = createContext({});
export function AuthLogin(props) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    console.log('AuthLoginInfo token ', token);
    if (!token) {
      setUser(null);
    } else {
      axios.get(`${config.apiEndpoint}/Account/validate-token`, { headers: { Authorization: `Bearer ${token}` }, withCredentials: true })
        .then(res => {
          console.log('AuthLoginInfo completed ', res.data);
          setUser(res.data);
        })
        .catch((err) => {
          console.log('AuthLoginInfo false ', err);
          setUser(null);
        });
    }
  }, []);

  return (
    <AuthLoginInfo.Provider value={user}>{props.children}</AuthLoginInfo.Provider>
  );
}
